















import { Vue, Component, Prop, InjectReactive } from "vue-property-decorator";
import MagicBlock from "./MagicBlock.vue";

@Component({
  name: "MagicBlockExt",
  components: { MagicBlock }
})
export default class MagicBlockExt extends Vue {
  @Prop({
    type: Object,
    required: true
  })
  public data!: {
    blockId: string;
    description: string;
    index: number;
    propertyName: string;
    propertyType: string;
    propertyTypeName: string;
  };

  @InjectReactive("htmlOptions")
  public htmlOptions!: {
    options: { template: string; widgets: App.WebForm.Widget[] };
    model: any;
  };

  get widget() {
    const widget = this.htmlOptions.options.widgets.find((d) => d.id === this.data.blockId);
    if (!widget) return {} as any;
    return widget;
  }
}
